import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=1058433b"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=1058433b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports